module.exports = __webpack_public_path__ + "static/media/bonusGame_1.19df3789.mp3";